const INVITE_TOKEN = /^[A-Za-z0-9_-]{1,128}$/

/** The login page's return address for re-opening an invite after switching accounts; null for anything that isn't an invite token. */
export function inviteLoginPath(apiUrl: string, token: string | null) {
	if (!token || !INVITE_TOKEN.test(token)) return null
	const inviteUrl = `${apiUrl}/invite/${token}`
	return `/login?redirectUrl=${encodeURIComponent(inviteUrl)}`
}
